import { atom } from "recoil";
//import { userState } from "./auth";

export const bannerOpenState = atom({
    key: 'bannerOpenState',
    default: true,
})
// export const bannerOpenState = atom({
//     key: 'bannerOpenState',
//     default: true,
//     effects: [
//         ({ setSelf, getLoadable }) => {
//             const user = getLoadable(userState).valueMaybe()
//             const username = user?.name ?? 'Unknown'
//             setSelf(() => getInitialBannerOpenState(username))
//         },
//         ({ onSet, getLoadable }) => {
//             const user = getLoadable(userState).valueMaybe()
//             const username = user?.name ?? 'Unknown'
//             onSet((newValue) => saveBannerOpenState(username, newValue))
//         },
//     ]
// })

const bannerOpenLocalstorageKey = (username: string) => `banner-open-${username}`

const saveBannerOpenState = (username: string, open: boolean) => {
    window.localStorage.setItem(bannerOpenLocalstorageKey(username), JSON.stringify({ open }))
}
const getInitialBannerOpenState = (username: string) => {
    let json = window.localStorage.getItem(bannerOpenLocalstorageKey(username))
    if(!json) {
        json =  '{ "open": true }'
        saveBannerOpenState(username, true)
    }
    const temp: { open: boolean } = JSON.parse(json)
    return temp.open
}


